/**
 * 画面共通のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const CommonGL = {
  /** Subscription Store */
  HeaderTitle: 'GL00100001',
  /** ログイン */
  LoginBtnTitle: 'GL00100002',

  /**
   * フッター用グロッサリID
   */
  /** プラン一覧 */
  PlanList: 'GL00160001',
  /** 利用ガイド */
  Guide: 'GL00160002',
  /** FAQ */
  Faq: 'GL00160003',
  /** お問い合わせ */
  ContactUs: 'GL00160004',
  /** 利用規約 */
  TermsOfService: 'GL00160005',
  /** プライバシーポリシー */
  PrivacyPolicy: 'GL00160006',
  /** クッキーポリシー */
  CookiePolicy: 'GL00160007',
  /** コピーライト */
  Copyright: 'GL00160008'
} as const;
export type CommonGLKeys = typeof CommonGL[keyof typeof CommonGL];
